import React from "react";
import TransitionFinish from "../pages/TransitionFinish";
import { useDispatch, useSelector } from "react-redux";
import { paymentActions } from "../store/payment";
import { AppState } from "../store";
import { useOnceCall } from "../custom-hooks/once-call";

const TransitionFinishContainer = () => {
    const dispatch = useDispatch();
    const payment = useSelector((state: AppState) => state.payment);
    // カード決済切り替え待ちのユーザーか否か
    const isWaitingToSwitchToCardPayment =
        payment.status.cardPaymentTransitionApplicationDate !== null;
    useOnceCall(() => {
        dispatch(paymentActions.selectedPaymentSet(null));
    });
    return (
        <TransitionFinish
            isWaitingToSwitchToCardPayment={isWaitingToSwitchToCardPayment}
        />
    );
};

export default TransitionFinishContainer;
